function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import { BotonImagen } from '../../botones';

var BotonAudio = function (_React$Component) {
  _inherits(BotonAudio, _React$Component);

  function BotonAudio(props) {
    _classCallCheck(this, BotonAudio);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handlePlay = function () {
      var playing = _this.state.playing;
      var audio = _this.audioRef.current;

      if (playing) {
        audio.pause();
        audio.currenttime = 0;

        _this.setState({
          playing: false
        });
      } else {
        _this.setState({
          playing: true
        }, function () {
          return audio.play();
        });
      }
    };

    _this.state = {
      src: props.src,
      playing: false
    };
    _this.audioRef = React.createRef();
    return _this;
  }

  BotonAudio.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var src = this.props.src;

    if (prevProps.src !== src) {
      this.setState({
        src: src,
        playing: false
      });
    }
  };

  BotonAudio.prototype.render = function render() {
    var src = this.state.src;
    return React.createElement(BotonImagen, {
      clases: 'botonAudioVisorImagenes',
      onClick: this.handlePlay
    }, React.createElement('audio', {
      ref: this.audioRef,
      src: src
    }));
  };

  return BotonAudio;
}(React.Component);

BotonAudio.propTypes = process.env.NODE_ENV !== "production" ? {
  src: t.string.isRequired
} : {};
export default BotonAudio;